import { PureComponent } from "react";
import BoardsAndQuotesCarouselComponent from "/components/core/boards-and-quotes-carousel/boards-and-quotes-carousel-component";
import SwitchingTitleWithSignupComponent from "/components/core/switching-title-with-signup/switching-title-with-signup-component";
import classnames from "classnames";

import { StyledSwitchingTitleWithQuotesCarouselComponent } from "./switching-title-with-quotes-carousel-component.scss";

export default class SwitchingTitleWithQuotesCarouselComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.setActive = this.setActive.bind(this);
    this.onCaruoselActiveChange = this.onCaruoselActiveChange.bind(this);
    this.incrementActiveIndex = this.incrementActiveIndex.bind(this);
    this.clearIncrementActiveIndexInterval = this.clearIncrementActiveIndexInterval.bind(this);
    this.setIncrementActiveIndexInterval = this.setIncrementActiveIndexInterval.bind(this);
    this.incrementActiveIndexInterval = null;

    this.state = { activeIndex: 0 };
  }

  componentDidMount() {
    const { animationInterval } = this.props;
    if (animationInterval) {
      this.setIncrementActiveIndexInterval();
    } else {
      this.clearIncrementActiveIndexInterval();
    }
  }

  setIncrementActiveIndexInterval() {
    const { animationInterval } = this.props;
    this.clearIncrementActiveIndexInterval();
    this.incrementActiveIndexInterval = setInterval(this.incrementActiveIndex, animationInterval);
  }

  incrementActiveIndex() {
    const { activeIndex } = this.state;

    const { useCases } = this.props;
    const nextActiveIndex = (activeIndex + 1) % useCases.length;
    this.setActive(nextActiveIndex);
  }

  setActive(activeIndex) {
    this.setState({ activeIndex });
  }

  onCaruoselActiveChange(activeIndex) {
    this.clearIncrementActiveIndexInterval();
    this.setActive(activeIndex);
  }

  componentWillUnmount() {
    this.clearIncrementActiveIndexInterval();
  }

  clearIncrementActiveIndexInterval() {
    if (this.incrementActiveIndexInterval) {
      clearInterval(this.incrementActiveIndexInterval);
    }
  }

  render() {
    const {
      useCases,
      title,
      subtitle,
      mobileTitle,
      showSignup,
      showSubtitle,
      showNavigationArrows,
      removeBoardBorder,
      aboveTheFold,
      signupForm,
      isMobileOrTabletBrowser
    } = this.props;

    const useAboveTheFoldLayout = aboveTheFold && !isMobileOrTabletBrowser;

    const activeIndex = Math.min(useCases.length - 1, this.state.activeIndex);
    if (!useCases[activeIndex]) return false;
    const switchingWords = {
      wordWidth: "124px",
      words: useCases.map((uc, i) => ({ ...uc.word, color: useCases[i].color }))
    };

    const stopAutoSlide = this.clearIncrementActiveIndexInterval;
    const startAutoSlide = this.setIncrementActiveIndexInterval;
    const showArrowsInQuotes = showNavigationArrows;

    return (
      <StyledSwitchingTitleWithQuotesCarouselComponent
        className={classnames("switching-title-with-quotes-carousel-component", {
          "above-the-fold": useAboveTheFoldLayout
        })}
      >
        <div className="switching-title-with-signup-wrapper">
          <SwitchingTitleWithSignupComponent
            title={title}
            subtitle={subtitle}
            switchingWords={switchingWords}
            activeIndex={activeIndex}
            mobileTitle={mobileTitle}
            showSignup={showSignup}
            showSubtitle={showSubtitle}
            aboveTheFold={useAboveTheFoldLayout}
            signupForm={signupForm}
          />
        </div>
        <div className="boards-and-quotes-carousel-wrapper">
          <BoardsAndQuotesCarouselComponent
            quotes={useCases}
            activeIndex={activeIndex}
            setActive={this.onCaruoselActiveChange}
            stopAutoSlide={stopAutoSlide}
            startAutoSlide={startAutoSlide}
            showNavigationArrows={showArrowsInQuotes}
            removeBoardBorder={removeBoardBorder}
            aboveTheFold={useAboveTheFoldLayout}
          />
        </div>
      </StyledSwitchingTitleWithQuotesCarouselComponent>
    );
  }
}

SwitchingTitleWithQuotesCarouselComponent.defaultProps = {
  title: "A new way to manage your",
  subtitle: "Plan, organize and track your work. All in one visual collaborative place",
  useCases: [
    {
      boardImage: "/static/img/community/board-image3.jpg",
      personTitle: "Bla Bla",
      personImage: "/static/img/exit-popup/exit-popup-social-proof-person-avater.png",
      quoteText:
        '"It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more "',
      active: true,
      word: {
        text: "workflows"
      },
      color: "brand-red"
    },
    {
      boardImage: "/static/img/lp/fb/designers-long/timeline.png20180125-30832-j2m2hz.png",
      personImage: "/static/img/jobs-page/cs.png",
      personTitle: "Tan Ha",
      quoteText:
        '"It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged"',
      active: false,
      word: {
        text: "work"
      },
      color: "brand-blue"
    },
    {
      boardImage: "/static/img/community/board-image2.jpg",
      personImage: "/static/img/jobs-page/design.png",
      personTitle: "Product Designer",
      quoteText: "123qweqwedawa dwkdj awkdj aw;kdj akw;ldj aw;kdj aw;kdj aklw;djaklw;d jawkld jakl;wdj ak;lwdj ",
      active: false,
      word: {
        text: "clients"
      },
      color: "brand-green"
    },
    {
      boardImage: "/static/img/s/car-manufacturing-management/high-level-board.png",
      personImage: "/static/img/s/construction-management-software/original-real_photo.png",
      personTitle: "Dude",
      quoteText:
        '"Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"',
      active: false,
      word: {
        text: "tasks"
      },
      color: "brand-purple"
    },
    {
      personTitle: "Tal",
      quoteText: "dawd awdawdaw da wd awd awd aw daw dawd",
      personImage: "/static/img/s/multitasking-work-productivity/Picture1.png",
      boardImage: "/static/img/s/agile-management-software/project_status.png",
      active: false,
      word: {
        text: "blabla"
      },
      color: "brand-iris"
    }
  ],
  animationInterval: "3000",
  paddingTop: "100px"
};

SwitchingTitleWithQuotesCarouselComponent.baseSegmentStyleOverride = {
  paddingLeft: 0,
  paddingRight: 0
};
